import { useCartStore } from './CartStore';

export function useOrderLineQuantity(itemVariantId: string): number {
  return useCartStore(
    (state) => state.cart.orderLines.find((line) => line.itemVariantId === itemVariantId)?.quantity ?? 0
  );
}

/**
 * Returns the total quantity of an item in the cart.
 * With nested components, all items in the order lines array are standalone (parent) items.
 * This is used for visual indicators (e.g., border highlighting) on menu items.
 */
export function useStandaloneOrderLineQuantity(itemVariantId: string): number {
  return useCartStore((state) =>
    state.cart.orderLines
      .filter((line) => line.itemVariantId === itemVariantId)
      .reduce((total, line) => total + line.quantity, 0)
  );
}

export const useTotalCartQuantity = () =>
  useCartStore((state) => {
    return state.cart.orderLines.reduce((acc, orderLine) => acc + orderLine.quantity, 0);
  });
